import { KhophieuService } from 'src/services/khophieu.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const KHOPHIEU_NEW_CARE_SUCCESS = 'KHOPHIEU:NEW_CARE_SUCCESS'
export const KHOPHIEU_LIST_SUCCESS = 'KHOPHIEU:FIND_ALL_SUCCESS'
export const KHOPHIEU_LIST_FAILD = 'KHOPHIEU:FIND_ALL_FAILD'
export const KHOPHIEU_COUNT_ASSIGN_SUCCESS = 'KHOPHIEU:COUNT_ASSIGN_SUCCESS'
export const KHOPHIEU_COUNT_ASSIGN_FAILD = 'KHOPHIEU:COUNT_ASSIGN_FAILD'

export const KHOPHIEU_CREATE_SUCCESS = 'KHOPHIEU:CREATE_SUCCESS'
export const KHOPHIEU_CREATE_FAILD = 'KHOPHIEU:CREATE_FAILD'

export const KHOPHIEU_IMPORT_SUCCESS = 'KHOPHIEU:IMPORT_SUCCESS'
export const KHOPHIEU_SAVE_SUCCESS = 'KHOPHIEU:SAVE_SUCCESS'
export const KHOPHIEU_SAVE_FAILD = 'KHOPHIEU:SAVE_SUCCESS'

export const KHOPHIEU_DEL_SUCCESS = 'KHOPHIEU:DEL_SUCCESS'
export const KHOPHIEU_DEL_FAILD = 'KHOPHIEU:DEL_FAILD'

export const KHOPHIEU_ONE_SUCCESS = 'KHOPHIEU:FIND_ONE_SUCCESS'
export const KHOPHIEU_ONE_FAILD = 'KHOPHIEU:FIND_ONE_FAILD'

export const KHOPHIEU_HISTORY_LIST_SUCCESS = 'KHOPHIEU:HISTORY_FIND_ALL_SUCCESS'
export const KHOPHIEU_HISTORY_LIST_FAILD = 'KHOPHIEU:HISTORY_FIND_ALL_FAILD'

export const KHOPHIEU_UPDATE_FILTER = 'KHOPHIEU:UPDATE_FILTER'

export const KHOPHIEU_ORDER_SUCCESS = 'KHOPHIEU:ORDER_SUCCESS'
export const KHOPHIEU_ORDER_FAILD = 'KHOPHIEU:ORDER_FAILD'

export const KHOPHIEU_UPDATE_HOMEPAGE_FILTER = 'KHOPHIEU:KHOPHIEU_UPDATE_HOMEPAGE_FILTER'

export const KHOPHIEU_HOMEPAGE_LIST_SUCCESS = 'KHOPHIEU:FIND_HOMEPAGE_LIST_SUCCESS'
export const KHOPHIEU_HOMEPAGE_LIST_FAILD = 'KHOPHIEU:FIND_HOMEPAGE_LIST_FAILD'

export const KHOPHIEU_HOMEPAGE_ONE_SUCCESS = 'KHOPHIEU:FIND_HOMEPAGE_ONE_SUCCESS'
export const KHOPHIEU_HOMEPAGE_ONE_FAILD = 'KHOPHIEU:FIND_HOMEPAGE_ONE_FAILD'

export const KHOPHIEU_LIMIT_UPDATE_HOMEPAGE_FILTER = 'KHOPHIEU:KHOPHIEU_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const KHOPHIEU_LIMIT_HOMEPAGE_LIST_SUCCESS = 'KHOPHIEU:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const KHOPHIEU_LIMIT_HOMEPAGE_LIST_FAILD = 'KHOPHIEU:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const KHOPHIEU_LIMIT_HOMEPAGE_ONE_SUCCESS = 'KHOPHIEU:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const KHOPHIEU_LIMIT_HOMEPAGE_ONE_FAILD = 'KHOPHIEU:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const KhophieuAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    sendOrder,
    proList,
}

function updateHomepageFilter(payload) {
    return { type: KHOPHIEU_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { khophieu } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageKhophieuFilter } = khophieu;
        const homepageKhophieuPage = homepageKhophieuFilter.homepageKhophieuPage;
        const homepageKhophieuLimit = homepageKhophieuFilter.homepageKhophieuLimit;

        return new Promise((resolve, reject) => {
            KhophieuService.homepageList(homepageKhophieuFilter).then((rs) => {
                if (!!homepageKhophieuFilter && homepageKhophieuFilter.homepageKhophieuPage === 0) {
                    dispatch(success({
                        homepageKhophieuItems: rs.data.values,
                        homepageKhophieuTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = khophieu.homepageKhophieuItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageKhophieuLimit * homepageKhophieuPage; i < homepageKhophieuLimit * homepageKhophieuPage + homepageKhophieuLimit; i++) {
                        if (typeof rsDataValues[i - homepageKhophieuLimit * homepageKhophieuPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageKhophieuLimit * homepageKhophieuPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageKhophieuItems: uniqueItems,
                        homepageKhophieuTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: KHOPHIEU_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: KHOPHIEU_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { khophieu } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageKhophieuLimitFilter } = khophieu;
        const homepageKhophieuLimitPage = homepageKhophieuLimitFilter.homepageKhophieuLimitPage;
        const homepageKhophieuLimitLimit = homepageKhophieuLimitFilter.homepageKhophieuLimitLimit;

        return new Promise((resolve, reject) => {
            KhophieuService.homepageLimitList(homepageKhophieuLimitFilter).then((rs) => {
                if (!!homepageKhophieuLimitFilter && homepageKhophieuLimitFilter.homepageKhophieuLimitPage === 0) {
                    dispatch(success({
                        homepageKhophieuLimitItems: rs.data.values,
                        homepageKhophieuLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = khophieu.homepageKhophieuLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageKhophieuLimitLimit * homepageKhophieuLimitPage; i < homepageKhophieuLimitLimit * homepageKhophieuLimitPage + homepageKhophieuLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageKhophieuLimitLimit * homepageKhophieuLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageKhophieuLimitLimit * homepageKhophieuLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageKhophieuLimitItems: uniqueItems,
                        homepageKhophieuLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: KHOPHIEU_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: KHOPHIEU_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhophieuService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhophieuAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: KHOPHIEU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhophieuService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhophieuAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: KHOPHIEU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { khophieu } = getState()
        dispatch(AppAction.appLoading(true));
        KhophieuService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...khophieu.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { khophieu } = getState();
        const page = khophieu && typeof khophieu.filter !== 'undefined' && khophieu.filter && typeof khophieu.filter.page !== 'undefined' ? khophieu.filter.page : 0;
        const limit = khophieu && typeof khophieu.filter !== 'undefined' && khophieu.filter && typeof khophieu.filter.limit !== 'undefined' ? khophieu.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            KhophieuService.findAll(page, limit, khophieu.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = khophieu.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: KHOPHIEU_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: KHOPHIEU_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            KhophieuService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(KhophieuAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: KHOPHIEU_SAVE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            KhophieuService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhophieuAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                // alert("Không thể tạo, có thể do trùng số phiếu trước đó!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: KHOPHIEU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(KhophieuAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(KhophieuAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_DEL_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        return new Promise((resolve, reject) => {
            KhophieuService.find(id).then((rs) => {
                dispatch(success(rs.data));
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: KHOPHIEU_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(KhophieuAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { khophieu } = getState()
        dispatch(AppAction.appLoading(true));
        KhophieuService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...khophieu.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        KhophieuService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt này do hiện tại đang tạm hết hàng. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHOPHIEU_ORDER_SUCCESS, data } }
    function failure(error) { return { type: KHOPHIEU_ORDER_FAILD, error } }
}

function proList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhophieuService.proList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}